.registreringContent {
  margin-top: var(--dds-spacing-medium-40);

  p {
    margin: var(--dds-spacing-medium-32) 0;
  }
}

.spinner {
  display: flex;
  justify-content: center;
  margin-top: var(--dds-spacing-medium-20);
}

.warning-banner {
  margin-top: var(--dds-spacing-small-8);
}
